module.exports = __webpack_public_path__ + "img/female.b7524b65.svg";